import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cropper from "react-easy-crop";
// import "./style.css";
import gallery from "../../../assets/common/galleryWhite.svg";
import {
  FlexColumnBetween,
  FlexRowBetween,
  GenericDiv,
} from "../../common/Style";
import { editDetails } from "../../../store/reducers/authReducer";
import { deletePhoto } from "../../../store/reducers/photosReducer";
import GenericModal from "../../common/modals/GenericModal";
import minusB from "../../../assets/common/minusB.svg";
import plusB from "../../../assets/common/plusB.svg";
import { toast } from "react-toastify";
import EditPics from "../others/EditPics";

const Image = ({ setPicPosition, setCropAreaAspect, setView, pic }) => {
  const [editPic, setEditPic] = useState(false);
  const { user } = useSelector((state) => state.authReducer);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [cropAreaAspectX, setCropAreaAspectX] = useState(user.cropAreaAspect.x);
  const [cropAreaAspectY, setCropAreaAspectY] = useState(user.cropAreaAspect.y);
  const [croppedArea, setCroppedArea] = useState(null);
  const dispatch = useDispatch();

  // const deletePhoto1 = async (id, pic) => dispatch(deletePhoto(id, pic));
  // const deletePhotoOnly = async () => {
  //   await deletePhoto1(data._id, data.pic);
  //   dispatch(editDishPic({ pic: "" }, data._id, data.category)).then(
  //     (res) => {
  //       if (!res.payload?.error)
  //         GetToast(addToast, "success", "הפעולה הצליחה!!");
  //       init();
  //     },
  //     (error) => {
  //       GetToast(addToast, "error", error);
  //     }
  //   );
  // };

  const deletePhoto1 = async () => dispatch(deletePhoto(user.pic));
  const deletePhotoOnly = async () => {
    await deletePhoto1();
    dispatch(editDetails({ pic: "" })).then((res) => {
      if (!res.payload?.error) toast.success("הפעולה הצליחה!!");
      else toast.error("הפעולה נכשלה, פנה לתמיכה");
    });
  };

  const save = () => {
    setPicPosition(croppedArea);
    setCropAreaAspect({ x: cropAreaAspectX, y: cropAreaAspectY });
    setView(false);
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ height: "50vh", position: "relative" }}>
        <Cropper
          image={pic}
          aspect={cropAreaAspectX / cropAreaAspectY}
          crop={crop}
          zoom={zoom}
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropAreaChange={(croppedArea) => {
            setCroppedArea(croppedArea);
          }}
        />
      </div>
      <FlexColumnBetween
        style={{ width: "90%", margin: "0px auto", minHeight: "70px" }}
      >
        <div>
          <GenericDiv
            style={{ marginTop: "20px" }}
            background={"#7b96c4"}
            onClick={() => save()}
          >
            הדמיה
          </GenericDiv>

          <GenericDiv
            style={{ marginTop: "20px" }}
            background={"#7b96c4"}
            onClick={() => {
              if (user.pic === "") {
                setEditPic(true);
              } else deletePhotoOnly();
            }}
          >
            <img
              src={gallery}
              alt={"gallery"}
              style={{ width: "20px", marginLeft: "10px" }}
            />
            <div>{user.pic === "" ? "העלאת תמונה" : "מחיקת תמונה"}</div>
          </GenericDiv>
        </div>

        <FlexRowBetween>
          <FlexRowBetween
            style={{
              flexDirection: "column",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <img
              src={plusB}
              alt={"plusB"}
              onClick={() => {
                if (cropAreaAspectY + 0.1 <= 10)
                  setCropAreaAspectY(cropAreaAspectY + 0.1);
              }}
              style={{
                width: "25px",
                boxShadow: "0 1px 2px gray",
                padding: "3px",
                marginBottom: "15px",
              }}
            />
            <img
              src={minusB}
              alt={"minusB"}
              onClick={() => {
                if (cropAreaAspectY + 0.1 >= 1)
                  setCropAreaAspectY(cropAreaAspectY - 0.1);
              }}
              style={{
                width: "25px",
                boxShadow: "0 1px 2px gray",
                padding: "3px",
              }}
            />
          </FlexRowBetween>

          <FlexRowBetween style={{ justifyContent: "center" }}>
            <div>{cropAreaAspectY.toFixed(1)}</div>
            <div style={{ margin: "0 3px" }}>/</div>
            <div>{cropAreaAspectX.toFixed(1)}</div>
          </FlexRowBetween>

          <FlexRowBetween
            style={{ justifyContent: "center", marginTop: "20px" }}
          >
            <img
              src={plusB}
              alt={"plusB"}
              onClick={() => {
                if (cropAreaAspectX + 0.1 <= 10)
                  setCropAreaAspectX(cropAreaAspectX + 0.1);
              }}
              style={{
                width: "25px",
                boxShadow: "0 1px 2px gray",
                padding: "3px",
                marginLeft: "15px",
              }}
            />
            <img
              src={minusB}
              alt={"minusB"}
              onClick={() => {
                if (cropAreaAspectX - 0.1 >= 1)
                  setCropAreaAspectX(cropAreaAspectX - 0.1);
              }}
              style={{
                width: "25px",
                boxShadow: "0 1px 2px gray",
                padding: "3px",
              }}
            />
          </FlexRowBetween>
        </FlexRowBetween>
      </FlexColumnBetween>
      {editPic && (
        <GenericModal
          init={setEditPic}
          div={<EditPics init={setEditPic} kind={"pic"} id={user._id} />}
        />
      )}
    </div>
  );
};

export default Image;
